import React from "react";
import { Link } from "react-router-dom";
import { DELIVERY_CHECKOUT_COPY } from "../../lib/delivery";
import { HOME_CTA_DARK_OUTLINE } from "../../lib/homeCta";

const preview = [
  {
    q: "What is the difference between Gold and Purple?",
    a: "Gold is smooth, simple, and everyday. Purple has a deeper colour and a richer look. Same fridge-ready gel, same simple routine.",
  },
  {
    q: "How do I use sea moss gel?",
    a: "Take a spoonful, blend it into smoothies, or stir it into oats, juice or tea. Start plain and keep it simple.",
  },
  {
    q: "Jar or pouch?",
    a: "Jar is fridge-ready and easy to spoon from. Pouch is lighter to send — same fresh gel.",
  },
  {
    q: "Do you deliver across the UK?",
    a: `Yes. UK orders only. Freshly prepared, packed carefully, sent across the UK. ${DELIVERY_CHECKOUT_COPY}`,
  },
];

/** Compact FAQ accordion — Inter via font-sans, high readability. */
export default function HomeFaqPreview() {
  return (
    <section id="home-faq" className="py-7 md:py-9 bg-void" aria-labelledby="home-faq-heading">
      <div className="max-w-2xl mx-auto px-6 md:px-10">
        <h2
          id="home-faq-heading"
          className="font-sans font-semibold text-xl md:text-2xl text-ivory text-center m-0 leading-snug tracking-tight"
        >
          Questions before you order
        </h2>
        <div className="mt-5 space-y-3 font-sans">
          {preview.map((item) => (
            <details
              key={item.q}
              className="group rounded-xl border border-[rgba(248,241,223,0.18)] bg-panel px-4 py-4 sm:px-5"
            >
              <summary className="font-sans font-semibold text-base sm:text-[1.05rem] text-ivory cursor-pointer list-none flex items-center justify-between gap-3 leading-snug">
                <span>{item.q}</span>
                <span className="text-gold text-xs group-open:rotate-180 transition shrink-0">▼</span>
              </summary>
              <p className="mt-3 text-[15px] sm:text-base text-sage leading-relaxed border-t border-[rgba(248,241,223,0.12)] pt-3 m-0 font-sans">
                {item.a}
              </p>
            </details>
          ))}
        </div>
        <div className="text-center mt-5">
          <Link to="/faq" className={`${HOME_CTA_DARK_OUTLINE} px-6 py-2.5 text-xs`}>
            Full FAQ
          </Link>
        </div>
      </div>
    </section>
  );
}
